/**
 * @module Section-Home2-Case-Study
 */

import { NavLink } from "react-router-dom";
import { navUrl } from "../../../../globals/common-functions";
import { route } from "../../../../globals/constants";
import { TypeSectionCaseStudy } from "../../../@types/sectionTypes";
import AvertImage from "../../../../globals/elements/avertimg";

const SectionHome2CaseStudy = (
    props: {
        _caseStudy: TypeSectionCaseStudy
    }
) => {
    const { _caseStudy } = props;
    return (
        <div className="av-cs-v2">
            <div className="section-full p-t120 p-b90 site-bg-white">
                <div className="container">
                    {/* Header */}
                    <div className="row align-items-end av-cs-header">
                        <div className="col-lg-8 col-md-7">
                            <div className="av-sh-label">Our Work</div>
                            <h2>{_caseStudy.title}</h2>
                            <p>{_caseStudy.subtitle}</p>
                        </div>
                        <div className="col-lg-4 col-md-5 text-md-right" style={{textAlign: 'right'}}>
                            <NavLink to={navUrl.pages(route.pages.CASE_STUDY)} className="av-cs-view-all">
                                View All Projects <i className="feather feather-arrow-right"></i>
                            </NavLink>
                        </div>
                    </div>

                    {/* Carousel */}
                    <div className="section-content">
                        <div className="owl-carousel sx-case-st-carousel">
                            {
                                _caseStudy.cases.map((_item, _index) => {
                                    const detailUrl = navUrl.pages(route.pages.PROJECT_DETAIL.replace(':projectId', _item.id));
                                    return (
                                        <div key={_index} className="item">
                                            <div className="av-cs-card">
                                                <div className="av-cs-img">
                                                    <NavLink to={detailUrl}>
                                                        <AvertImage src={_item.image} alt={`${_item.subtitle} - Anathoth Technologies`} />
                                                    </NavLink>
                                                    <div className="av-cs-overlay"></div>
                                                    <NavLink to={detailUrl} className="av-cs-arrow">
                                                        <i className="feather feather-arrow-up-right" />
                                                    </NavLink>
                                                </div>
                                                <div className="av-cs-body">
                                                    <div className="av-cs-cats">
                                                        {
                                                            _item.categories.map((_category, _catIndex) => (
                                                                <NavLink to={navUrl.pages(route.pages.CASE_STUDY)} key={_catIndex} className="av-cs-cat">
                                                                    {_category}
                                                                </NavLink>
                                                            ))
                                                        }
                                                    </div>
                                                    <NavLink to={detailUrl} className="av-cs-title">
                                                        <h3 className="av-cs-title">{_item.subtitle}</h3>
                                                    </NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default SectionHome2CaseStudy;
